import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
// Components
import SaleCodesForm from './SaleCodesForm';
import OrderItems from './OrderItems';

// State
import {
    setOrderNotes,
    setActiveCheckoutSection,
    setOrderReviewComplete,
} from '../../../store/actions/checkout';
import { checkSaleCodesAvailable } from '../../../store/actions/saleCodes';

// CSS
import '../../../css/order-review.css';

// Util
import { setCheckoutSectionComplete as setCheckoutSectionCompleteGA } from '../../../utils/google-analytics';

class OrderReviewSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notes: this.props.notes,
            maxNoteLength: 255,
        };
    }

    componentDidMount() {
        this.props.checkSaleCodesAvailable();
    }

    handleInputChange(event) {
        this.setState({
            [event.target.id]: event.target.value,
        });
    }

    formatDate(pickupDate) {
        const date = moment(pickupDate, 'YYYY-MM-DD HH:mm:ss');
        const dateString = date.format('MMMM Do YYYY, h:mm a');
        return dateString;
    }

    handleSubmit = () => {
        this.props.setOrderNotes(this.state.notes);

        // Set current section as complete
        setCheckoutSectionCompleteGA(6);

        this.props.setActiveCheckoutSection('payment');
        this.props.setOrderReviewComplete();
    };

    render() {
        const { shipping, billing, pickupDate } = this.props;

        return (
            <div>
                <div className="delivery-heading">
                    <h2>Review your order:</h2>
                </div>

                <div className="container">
                    {/* SHIPPING */}
                    <div className="review-section">
                        <h4>
                            {this.props.isStore &&
                            this.props.shipping.skip_shipping_location
                                ? 'Pickup'
                                : 'Shipping'}
                        </h4>
                        <div>
                            {shipping.fname} {shipping.lname}
                        </div>
                        {shipping.company && <div>{shipping.company}</div>}
                        <div>{shipping.address}</div>
                        {shipping.address2 && <div>{shipping.address2}</div>}
                        <div>
                            {shipping.city}, {shipping.postal} {shipping.province}{' '}
                            {shipping.country}
                        </div>
                        {shipping.phone && <div>{shipping.phone}</div>}
                        <p>
                            <strong>
                                {!!pickupDate ? this.formatDate(pickupDate) : ''}
                            </strong>
                        </p>
                    </div>

                    {/* BILLING */}
                    <div className="review-section">
                        <h4>Billing</h4>
                        <div>
                            {billing.fname} {billing.lname}
                        </div>
                        {billing.company && <div>{billing.company}</div>}
                        <div>{billing.address}</div>
                        {billing.address2 && <div>{billing.address2}</div>}
                        <div>
                            {billing.city}, {billing.postal} {billing.province}{' '}
                            {billing.country}
                        </div>
                        {billing.phone && <div>{billing.phone}</div>}
                    </div>

                    <div className="hbs-order-review-items">
                        <OrderItems />
                    </div>
                </div>

                <SaleCodesForm />

                <div className="order-notes">
                    <h3>Notes to seller</h3>
                    <textarea
                        value={this.state.notes}
                        id="notes"
                        onChange={(event) => this.handleInputChange(event)}
                        maxLength={this.state.maxNoteLength}
                    />
                </div>

                <div className="container review-buttons">
                    <Link to={'/'}>Continue shopping</Link>
                    <div className="btn" onClick={() => this.handleSubmit()}>
                        Continue to payment
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        shipping: state.checkout.shipping,
        billing: state.checkout.billing,
        notes: state.checkout.notes,
        codesAreLoading: state.saleCodes.isLoading,
        codesAvailable: state.saleCodes.codesAvailable,
        isPickup: state.cart.is_pickup,
        pickupDate: state.pickup.pickupDate,
        isStore: state.checkout.isStore,
    };
};

export default connect(
    mapStateToProps,
    {
        checkSaleCodesAvailable,
        setOrderNotes,
        setActiveCheckoutSection,
        setOrderReviewComplete,
    }
)(OrderReviewSection);



// WEBPACK FOOTER //
// ./src/components/checkout/order-review/OrderReviewSection.js